import CasemanagementList from "../../components/Casemanagement/CasemanagementList";

export default function Casemanagement(){
    return(
        <div>
            <CasemanagementList/>
        </div>
    )
}